export default __webpack_public_path__ + "static/media/CPD_Relaxed_Policy_Updated_31 dec 2020.5dc28591.pdf";